<template>
    <div v-if="loaded">
        <card-header title="Request Changes" icon="fa-comment-dots"/>

        <card-body>
            <div class="px-4 py-3">
                <div class="box mb-4" style="background-color: #f8f9fa;">
                    <div class="has-text-weight-bold">{{ plan.course_title }}</div>
                    <div class="is-size-7 has-text-grey mt-1">{{ plan.first_name }} {{ plan.last_name }}</div>
                </div>

                <b-field label="Feedback Message" message="Provide clear feedback about what changes are needed">
                    <b-input
                        type="textarea"
                        v-model="feedback"
                        placeholder="Please describe what changes need to be made to the study plan..."
                        rows="6"
                    ></b-input>
                </b-field>

                <p class="is-size-7 has-text-grey mt-4">
                    <i class="fas fa-info-circle mr-1"></i>
                    The student will receive an email notification with your feedback and will be able to revise and resubmit their study plan.
                </p>
            </div>
        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <b-button type="is-light" size="is-small" @click="$closeCard(card)">
                        Cancel
                    </b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-warning"
                        size="is-small"
                        @click="sendFeedback"
                        :loading="sending"
                        :disabled="!feedback.trim()"
                    >
                        <i class="fas fa-paper-plane mr-2"></i>
                        Send Feedback
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import {client as http} from "@/http_client";
    import {mapActions} from "vuex";

    export default {
        components: {CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                plan: null,
                feedback: '',
                loaded: false,
                sending: false
            };
        },
        methods: {
            ...mapActions(['getStudyPlansCount']),
            load() {
                this.$emit('loading', true);
                http.get(`/study-plans/${this.props.enrollmentId}`, {force: true}).then(response => {
                    this.plan = response.data;
                    this.loaded = true;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading study plan:', err);
                    this.$emit('loading', false);
                });
            },
            sendFeedback() {
                if (!this.feedback.trim()) {
                    this.$buefy.toast.open({
                        message: 'Please enter feedback',
                        type: 'is-warning'
                    });
                    return;
                }

                this.sending = true;
                http.post(`/study-plans/${this.props.enrollmentId}/reject`, {
                    feedback: this.feedback
                }).then(() => {
                    this.$buefy.toast.open({
                        message: 'Feedback sent to student',
                        type: 'is-success'
                    });
                    this.getStudyPlansCount();
                    this.$closeCard(this.card);
                    this.$closeCard('study-plan-detail');
                    this.$reloadCard('study-plans');
                }).catch(err => {
                    console.error('Error sending feedback:', err);
                    this.$buefy.toast.open({
                        message: 'Error sending feedback',
                        type: 'is-danger'
                    });
                }).finally(() => {
                    this.sending = false;
                });
            }
        },
        mounted() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
</style>
